import { BusinessGooglePlace } from "../../interfaces/BusinessObject";
import { convertBusinessGooglePlace } from "../converters/backendToUi/businessGooglePlaceConvertor";
import { loadGoogleMapsAPI } from "../../components/shared/PlaceSearch/helpers/PlacesSearchHelper";
import { getGooglePlaceId } from "../helpers/BusinessLocationHelper";
/** Uses the same browser key and Places library as the home-page location search. */
export async function getGooglePlaceRating(
  placeId: string,
  signal: AbortSignal,
): Promise<BusinessGooglePlace | null> {
  const id = getGooglePlaceId(placeId);
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY?.trim();
  if (!id || !apiKey || signal.aborted) return null;

  await loadGoogleMapsAPI(apiKey, () => {});
  if (signal.aborted) return null;
  const { Place } = await google.maps.importLibrary("places") as google.maps.PlacesLibrary;
  if (signal.aborted) return null;

  const place = new Place({ id });
  await place.fetchFields({ fields: ["rating", "userRatingCount", "googleMapsURI", "attributions"] });
  // Google's SDK cannot cancel an issued request; ignore results after navigation/timeout.
  if (signal.aborted) return null;
  return convertBusinessGooglePlace({
    placeId: place.id,
    rating: place.rating,
    userRatingCount: place.userRatingCount,
    googleMapsUri: place.googleMapsURI,
    attributions: place.attributions?.map(({ provider, providerURI }) => ({
      provider,
      providerUri: providerURI,
    })),
  }, id);
}


